import {MyScoresLinkParams} from "./my-scores-container-link-params";
import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import {ROUTE_NAMES} from "../../../core/consts";
import {BaseLinkModelSettings} from "../../../infrastructure/models/link/base-link-model-settings";
import {APP} from "../../../core/app/consts";

export class MyScoresLinkModel extends BaseLinkModel  {
  screen: APP.ANALYTICS.SOURCES;

  constructor(filter: String = '',resetState: Boolean = false, refreshPage: Boolean = false) {
    super(ROUTE_NAMES.myScoresPage, new MyScoresLinkParams(filter));

    this.settings = new BaseLinkModelSettings(refreshPage, resetState);
    this.screen = APP.ANALYTICS.SOURCES.myScoresPage;
  }
}
